import React from "react"
import { useSelector } from "react-redux"

import { useAppDispatch } from "@root/store"
import { selectChannelAttributes } from "@root/store/selectors"
import { removeChannelAttribute, setChannelAttribute } from "@root/store/thunks"
import { Attribute } from "@root/store/types"
import Attributes from "@root/components/Attributes"

const ChannelAttributes: React.FC = () => {
  const attributes = useSelector(selectChannelAttributes)
  const dispatch = useAppDispatch()

  const setAttribute = React.useCallback(
    (attr: Attribute) => {
      dispatch(setChannelAttribute(attr))
    },
    [dispatch]
  )

  const removeAttribute = React.useCallback(
    (attr: Attribute) => {
      dispatch(removeChannelAttribute(attr))
    },
    [dispatch]
  )

  return (
    <Attributes
      attributes={Object.values(attributes)}
      onSetAttribute={setAttribute}
      onRemoveAttribute={removeAttribute}
    />
  )
}

export default ChannelAttributes
